import accountImgDefault from "@/assets/svgs/account-img-default.svg";
import { assetUrl } from '@/utils/asset-url';
import { useSelector } from "react-redux";
import rem from '@/utils/rem'

export const AccountSetting = ({setLoading}) => {
	const profile = useSelector((state) => state.auth.profile);

	function onImageError(event) {
		const { target } = event;
		if (!target) {
			return;
		}
		target.onerror = null;
		target.src = accountImgDefault;
	}

	return (
		<>
			<div className="account-setting-box__layout">
				<div className="account-setting-box__top">
					<div className="account-setting-box__top__background">
						<img className="account-setting-avatar__top__image"
							style={{ backgroundImage: `url(${profile?.organization?.iconUrl || accountImgDefault})`, textAlign:'center' }}
							onError={onImageError}
							data-testid="account-img"/>
					</div>
					<div className="account-setting-box__top__text">
						<p className="account-setting-box__top__text__name" data-testid="desc-account-name">{profile?.firstName}</p>
						<p className="account-setting-box__top__text__org" data-testid="desc-org-name">{profile?.organization?.name}</p>
					</div>
				</div>
				<div className="account-setting-box__bottom">
					<div className="account-setting-box__bottom__email">
						<span className="account-setting-box__bottom__text">Email Address</span>
						<input type="text" placeholder={profile.email} style={{width:rem(368)}} disabled={true} data-testid="input-email"/>

					</div>
					<div className="account-setting-box__bottom__password">
						<span className="account-setting-box__bottom__text">Password</span>
						<input type="password" style={{width:rem(368)}} placeholder="*************" disabled={true} data-testid="input-password"/>
					</div>
				</div>
			</div>
		</>
	);
};
